// ─────────────────────────────────────────────────────────────────
// Glass-i — Proforma Grid Settings API client (Stage 6Q.4).
//
// Tenant-wide Proforma grid column visibility (singleton). Thin axios
// wrappers around /api/erp/masters/proforma-grid-settings.
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/proforma-grid-settings';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : (resp ? resp.data : null);
}

export const proformaGridSettingsApi = {
  get:    ()        => client.get(BASE).then(unwrap),
  update: (payload) => client.put(BASE, payload).then(unwrap)
};

// Soft-fail loader for the Proforma editor — never blocks the grid.
export async function loadProformaGridSettingsSafe() {
  try { return await proformaGridSettingsApi.get(); }
  catch (_e) { return null; }
}

export default proformaGridSettingsApi;
